import React, { useRef, useState } from 'react';
import './dataQuality.scss';
import { apiQueryWithToken } from '../../common/services/apiBaseUrlConfig';
import { MotifTable } from '@ey-xd/motif-react';
import { TableHeader } from './TableHeader';
import { useNavigate } from "react-router-dom";
import { MotifProgressLoader } from '@ey-xd/motif-react';
import { Stepper } from '../stepper/stepper';
import logger from "../../common/utils/logger";

export const DataQuality = () => {
    const [searchValue, setSearchValue] = useState('');
    const [dataQualityData, setDataQualityData] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);

    const filteredData = Object.values(dataQualityData?.filter((item) => { return item.fileName.toLowerCase().includes(searchValue.toLowerCase()) })
    );


    React.useEffect(() => {
        getData();
        const intervalId = setInterval(getData, 20000);
        return () => clearInterval(intervalId);
    }, []);

    const gridRef = useRef();
    const navigation = useNavigate();

    const onFilterTextBoxChanged = (value) => {
        logger.info('QQ filter', value, gridRef);
        setSearchValue(value);
    };

    const getData = React.useCallback(() => {
        setIsLoading(true);
        apiQueryWithToken.get(`api/fileupload/DataQuality`).then((data) => {
            setDataQualityData(data.data.dataQualityList);
            setIsLoading(false);
        })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    navigation('/');
                    } else{
                      logger.error('An error occurred:', error);
                      setIsLoading(false);
                    }
            });
    })


    const columnDefs = [
        {
            field: 'controlId',
            headerName: 'ID',
            width: 80
        },
        {
            field: 'fileName',
            headerName: 'File Name',
            width: 120
        },
        {
            field: 'fileType',
            headerName: 'File Type',
            width: 120
        },
        {
            field: 'area',
            filter: true,
            headerName: 'Area',
            width:120
          },
        {
            field: 'region',
            filter: true,
            headerName: 'Region',
            width:120
          },
        {
            field: 'country',
            filter: true,
            headerName: 'Country',
            width: 130
        },
        {
            field: 'sector',
            filter: true,
            headerName: 'Sector',
            width: 120
        },
        {
            field: 'subSector',
            filter: true,
            headerName: 'Subsector',
            width: 140
        },
        {
            field: "subSubSector",
            filter: true,
            headerName: "Sub-Sub Sector",
            width: 170,
          },
        {
            field: 'function',
            filter: true,
            headerName: 'Function',
            width: 130
        },
        {
            cellRenderer: dotCellRenderer,
            field: 'dataQualityStatus',
            headerName: 'Data Quality Status',
            width: 180
        },
        {
            field: 'uploadedBy',
            headerName: 'Uploaded By',
            width: 300
        }
    ];

    return (
        <div className='fileUpload-container'>
            <div className='page-title-wrap'>
                <h3>Data Quality</h3>
            </div>
            <Stepper />
            {
                filteredData &&  <div className='grid-wrapper'>
                <TableHeader
                    onFilterTextBoxChanged={onFilterTextBoxChanged}
                    searchValue={searchValue}
                    navigation={navigation}
                />
                <div className='grid-container'>
                    <div className={'ag-theme-quartz grid-container-inner'}>
                        {
                            isLoading ? <MotifProgressLoader
                                show
                                variant="default"
                            /> : <MotifTable
                                columnDefs={columnDefs}
                                description='Descriptive text that describes your page or content.'
                                name='Default'
                                pagination
                                paginationPageSize={10}
                                paginationPageSizeSelector={[3, 4, 5]}
                                rowData={filteredData}
                                zebra={false}
                            />
                        }
                    </div>
                </div>
            </div>
            }
        </div>
    );
};

const dotCellRenderer = ({ value }) => {

    const showStatus = value?.replace(/\s/g, '').toLowerCase();
    return (
        <div
            className={`motif-dot ${showStatus === 'inprogress' && 'motif-dot-left'} ${(showStatus === 'success' || showStatus === 'completed') && 'motif-dot-success'
                } ${showStatus === 'failed' && 'motif-dot-error'} ${showStatus === 'inprogress' && 'motif-dot-warning'
                }`}
        >
            <span className='motif-dot-text'>{value}</span>
        </div>
    );
};
